<template>
  <div id="employee-employee-add">
    <vx-card>
      <div class="vx-row">
        <div class="vx-col w-full md:w-1/2">
          <vs-input
            class="w-full mt-4"
            :label="$t('users.id')"
            v-model="employeeData.userId"
            name="userId"
            v-validate="'required'"
            data-vv-validate-on="blur"
            :data-vv-as="$t('users.id')"
            :placeholder="$t('users.id')"
          />
          <span class="text-danger text-sm" v-show="errors.has('userId')">{{ errors.first('userId') }}</span>
        </div>
        <div class="vx-col w-full md:w-1/2">
          <div class="w-full mt-4">
            <label class="vs-input--label">{{ $t('entity.state') }}</label>
            <v-select
              v-model="employeeData.status"
              :clearable="false"
              :options="statusOptions"
              :reduce="option => option.value"
              v-validate="'required'"
              name="plan"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            />
            <span class="text-danger text-sm" v-show="errors.has('plan')">{{ errors.first('plan') }}</span>
          </div>
        </div>
      </div>
      <!-- Save & Reset Button -->
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mt-8 flex flex-wrap items-center justify-end">
            <vs-button class="ml-auto mt-2" @click="addEmployee" :disabled="!validateForm">{{
              $t('forms.add')
            }}</vs-button>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
// Store Module
import moduleEmployee from '@/store/employee/moduleEmployee.js'

export default {
  name: 'EmployeeAdd',
  data() {
    return {
      employeeData: {},
      plansEnum: []
    }
  },
  computed: {
    validateForm() {
      return !this.errors.any() && Object.keys(this.employeeData).length !== 0
    },
    statusOptions() {
      return this.$store.getters['enum/selectOptions']('EmployeeStatus', 'employees.status')
    }
  },
  methods: {
    addEmployee() {
      this.$vs.loading()
      if (!this.validateForm) return
      this.$store
        .dispatch('employee/createEmployee', this.employeeData)
        // eslint-disable-next-line no-unused-vars
        .then(res => {
          this.$vs.notify({
            color: 'success',
            title: this.$t('forms.successfully_created')
          })
          this.$router.push({ name: 'business-employee-view', params: { id: res.data.id } })
        })
        .catch(err => {
          if (err.response.status === 409) {
            this.$vs.notify({
              color: 'danger',
              title: this.$t('employees.exists')
            })
          }
        })
        .finally(() => this.$vs.loading.close())
    }
  },
  created() {
    // Register Module Employee Module
    if (!moduleEmployee.isRegistered) {
      this.$store.registerModule('employee', moduleEmployee)
      moduleEmployee.isRegistered = true
    }
  }
}
</script>
